import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  ["Is the briefing free?", "Yes. The briefing is free, and there is no cost to book or attend."],
  ["Can I attend from abroad?", "Yes. Briefings can be attended from anywhere. The booking calendar shows times in your own local time zone, together with the matching Dubai time (GST, UTC+4)."],
  ["Do I need to be ready to buy?", "No. The briefing is for understanding the market and your options. There is no obligation to buy anything."],
  ["Can we discuss specific properties?", "Yes. If you have projects or areas in mind, share them in the registration form and we can look at them together during the briefing."],
  ["Are investment returns guaranteed?", "No. Rental income and capital appreciation are never guaranteed. Property values and rents can go down as well as up, and every investment carries risk."],
  ["What happens after the briefing?", "You decide. You leave with clearer information and better questions. If you want to explore further, we can agree on next steps — with no pressure either way."],
];

export function FAQ() {
  return (
    <section className="py-24 sm:py-32 px-6 sm:px-10 bg-white" data-testid="faq-section">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-4">
          <p className="eyebrow">FAQ</p>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl font-bold text-[#0B1F3A]">Straight answers.</h2>
        </Reveal>
        <Reveal className="lg:col-span-8" delay={0.08}>
          <Accordion type="single" collapsible className="border-t border-[rgba(20,35,55,0.10)]">
            {FAQS.map(([q, a], i) => (
              <AccordionItem key={q} value={`faq-${i}`} className="border-[rgba(20,35,55,0.10)]">
                <AccordionTrigger className="py-6 text-left font-display text-lg font-semibold text-[#172033] hover:no-underline" data-testid={`faq-trigger-${i}`}>
                  {q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-[#697386] pr-8" data-testid={`faq-answer-${i}`}>
                  {a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
